import React from 'react'

import loader from './hint-indicator.json'

import LottieRenderer from '@/components/LottieRenderer'

export const MenuHint = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <LottieRenderer source={loader} height={32} width={32} />
    </div>
  )
}
